<div class="page flex min-h-screen flex-col">
  <!-- Brand header bar -->
  <header class="topbar flex items-center justify-between px-6">
    <div class="brand flex items-center gap-2">
      <span class="brand-name">CDW AmplifiedIT</span>
      <span class="brand-sep">|</span>
      <span class="brand-product">Platform Admin</span>
    </div>
    <span class="env-badge" [class.env-prod]="environmentLabel === 'PRODUCTION'">
      {{ environmentLabel }}
    </span>
  </header>

  <!-- Hero -->
  <main class="hero grow flex items-center">
    <div class="hero-inner mx-auto flex w-full flex-col items-center gap-12 px-6 py-12 md:flex-row">
      <!-- Left: copy + sign in -->
      <div class="hero-copy flex basis-1/2 flex-col gap-6">
        <div class="flex flex-col gap-3">
          <h1 class="headline">
            <strong>Platform administration</strong> for the CDW&nbsp;AmplifiedIT team.
          </h1>
          <p class="lede">
            Internal tools for customer success, onboarding, and platform operations.
          </p>
        </div>

        <div class="access-note flex items-start gap-2">
          <lib-cdw-icon class="login-warning" icon="warning" size="20px"></lib-cdw-icon>
          <span>
            For authorized team members. Sign in with your
            @for (domain of allowedDomains; track domain) {
              @if (!$first) {{{ $last ? (allowedDomains.length > 2 ? ', or ' : ' or ') : ', ' }}}
              <strong>&#64;{{ domain }}</strong>
            }
            account.
          </span>
        </div>

        <div class="flex flex-col gap-3">
          <button
            type="button"
            class="login-btn"
            (click)="handleGoogleLogin()"
            [disabled]="isLoading"
          >
            <span *ngIf="isLoading" class="spinner"></span>
            <span>{{ isLoading ? 'Authenticating…' : 'Log in with Google Workspace' }}</span>
          </button>

          <div *ngIf="loginError" class="login-error flex items-start gap-2">
            <lib-cdw-icon icon="warning" size="20px" [customColor]="'#b91c1c'"></lib-cdw-icon>
            <span>{{ loginError }}</span>
          </div>

          <div class="help-text">
            Access is provisioned by the CDW AmplifiedIT platform team.
          </div>
        </div>
      </div>

      <!-- Right: support mascot -->
      <div class="hero-art flex basis-1/2 justify-center">
        <img src="images/gopher_support.png" alt="Gopher support mascot" class="mascot" />
      </div>
    </div>
  </main>

  <!-- Brand footer bar -->
  <footer class="footbar flex items-center justify-between px-6">
    <div class="foot-links flex items-center gap-3">
      <a [href]="privacyUrl" target="_blank">Privacy Policy</a>
    </div>
    <div class="version">v{{ version }} &middot; {{ revision }}</div>
  </footer>
</div>
